export default {
  isDesktop: function() {
    if(!window){ return true; }
    return window.matchMedia("(min-width: 1023px)").matches;
  },
  cleanText: function(text){
    return text
      .toLowerCase()
      .replace(/[']+/g,'')
      .replace(/[\s_!@#$%^&*()"?><|}{\\\]\[\.,]+/g,' ')
      .trim()
      .replace(/[\s]+/g,'-');
  },
  getUrlTitle: function(pageId) {
    
    let page = matrixData.pages[pageId];

    if(!pageId || !page || pageId == matrixData.topLevelPage) { return matrixData.urlHome }

    let { title, titleAdditional } = page,
        additional = this.cleanText(titleAdditional);

    return matrixData.urlHome + '?page=' + pageId + '&title=' + this.cleanText(title) + (additional?'-':'') + additional;
  },
}
    
